import React, { useState } from "react";
import styles from "./auth.module.css";
import { useFormik } from "formik";
import * as yup from "yup";
import InputCustom from "./InputCustom";
import axios from "axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap/dist/css/bootstrap.min.css";

const Login = () => {
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const initialValues = {
    phone: "",
  };
  const onSubmit = (state) => {
    setLoader(true);
    const authCheckData = {
      tel: state.phone,
    };
    axios
      .post(
        "https://arianaapp.arianaapply.com/panel/check-admin-for-panel",
        authCheckData
      )
      .then((res) => {
        setLoader(false);
        console.log(res);
        if (res.data.status === 401) {
          Swal.fire({
            title: "اجازه دسترسی ندارید",
            icon: "error",
          });
        } else {
          Swal.fire({
            title: "برای ورود رمز عبور خود را وارد کنید",
            icon: "success",
          }).then(() => {
            history.push({
              pathname: "/auth-code",
              state: { phone: state.phone },
            });
          });
        }
      })
      .catch((err) => {
        setLoader(false);
        Swal.fire({
          title: "مشکلی پیش امده دوباره امتحان کنید",
          icon: "error",
        });
      });
  };
  const phoneRegex = new RegExp("^{?(0?9[0-9]{9,9}}?)$");
  const validationSchema = yup.object({
    phone: yup
      .string()
      .required("وارد کردن شماره تماس الزامیست")
      .matches(phoneRegex, "شماره تماس نامعتبر است")
      .nullable(),
  });
  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <div className={styles.authPage}>
      <form className={styles.authForm} onSubmit={formik.handleSubmit}>
        <h4 className={styles.authTitle}>
          احراز هویت پنل اپلیکیشن آریانا پارس
        </h4>
        <InputCustom
          name="phone"
          type="text"
          label="شماره تماس:"
          formikHandler={formik.getFieldProps("phone")}
          formikErrors={formik.errors.phone && formik.touched.phone}
          formikErrorsName={formik.errors.phone}
        />

        <button
          className={styles.submitButton}
          type="submit"
          disabled={!formik.isValid}
        >
          {loader ? (
            <Spinner animation="border" variant="light" />
          ) : (
            "احراز هویت"
          )}
        </button>
        <span
          className={styles.authPush}
          onClick={() => history.push("/register")}
        >
          هنوز ثبت نام نکرده اید؟
        </span>
      </form>
    </div>
  );
};

export default Login;
